module.exports = __webpack_public_path__ + "img/crush_light_natural_ba_list.8169f0fb.jpg";